import { IItemComboBaseDTO } from "../interfaces/base/IBase";
import { Ifilter } from "../interfaces/IFilter";
import { IGuardia, IGuardiaPaxFilter } from "../interfaces/IGuadia";
import { fetchMovilizacion } from "./http-common";

const urlGuardia = 'Guardia';

const allGuardia = (filter: Ifilter) => {
    return fetchMovilizacion.get(`${urlGuardia}?Skip=${filter.skip}&Take=${filter.take}&Search=${filter.search}&CodigoTipoProgramacion=${filter.CodigoTipoProgramacion}`);
}

const addGuardia = (data: IGuardia) => {
    return fetchMovilizacion.post(urlGuardia, data);
}

const editGuardia = (data: IGuardia) => {
    return fetchMovilizacion.put(urlGuardia, data);
}

const deleteGuardia = (id: string) => {
    return fetchMovilizacion.delete(`${urlGuardia}/${id}`);
}

const guardiaListaPax = (filter : IGuardiaPaxFilter, controller = new AbortController()) => {
    return fetchMovilizacion.get(`${urlGuardia}/ListaPax?GuardiaId=${filter.guardiaId}&Skip=${filter.skip}&Take=${filter.take}&Search=${filter.search}`, {signal : controller.signal});
}

const comboGuardiasProgramacion = (filter: Ifilter, controller = new AbortController()) => {
    return fetchMovilizacion.get<IItemComboBaseDTO[]>(`${urlGuardia}/Combo/Horarios`, {
        params: filter,
        signal: controller.signal
    });
}

const GuardiaService = {
    allGuardia,
    addGuardia,
    editGuardia,
    deleteGuardia,
    guardiaListaPax,
    comboGuardiasProgramacion
}

export default GuardiaService;